import { createFileRoute } from "@tanstack/react-router"
import { Crumb } from "modules/shared/lib/breadcrumbs"

export const Route = createFileRoute(
  "/_base/_auth/backoffice/organizations/$id/companies/$companyId/canonical-topics",
)({
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("backoffice.canonicalTopics.title"),
    })
  },
})
